import React from "react";
import defaultCroupierImage from "../../../../assets/casino/croupier.png";

function CasinoNoticeModal({
  message,
  croupierImage = defaultCroupierImage,
  actionLabel = "CLOSE",
  onClose,
}) {
  if (!message) {
    return null;
  }

  return (
    <div className="casino-modal-layer casino-notice-layer" role="presentation">
      <div className="casino-notice-composition">
        <div
          className="casino-notice-croupier"
          aria-hidden="true"
        >
          <img
            src={croupierImage}
            alt=""
            draggable="false"
          />
        </div>

        <div
          className="casino-notice-modal"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="casino-notice-title"
        >
          <p className="casino-modal-kicker">CASINO NOTICE</p>
          <h2 id="casino-notice-title" className="casino-notice-title">
            {message}
          </h2>
          <button type="button" className="casino-button" onClick={onClose}>
            {actionLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CasinoNoticeModal;
